<div id="toast-container" class="toast-top-right" popover="manual" #container>
	@for (toast of toastr.toasts(); track toast.id) {
		<div
			[class]="toastClass(toast)"
			(click)="toastr.remove(toast.id)"
			(mouseenter)="toastr.pause(toast.id)"
			(mouseleave)="toastr.resume(toast.id)"
		>
			@if (toast.closeButton) {
				<button type="button" class="toast-close-button" aria-label="Sluiten" (click)="toastr.remove(toast.id); $event.stopPropagation()">
					<span aria-hidden="true">&times;</span>
				</button>
			}
			<div class="toast-message" role="alert" aria-live="polite">{{ toast.message }}</div>
		</div>
	}
</div>
